module.exports = __webpack_public_path__ + "img/online-users-white.77e344c0.svg";